<template>
    <div class="feedbackComment">
      <label for="commentTextArea" class="label">{{ $texter.skrivKommentar }}</label>
      <div class="commentForm">
        <div>
          <textarea
            id="commentTextArea"
            class=""
            v-model="commentText"
            :maxlength="1999"
            :aria-invalid="validated">
          </textarea>

          <div class="comment-error" v-if="validatedCommentText" role="alert">
              <span>{{ $texter.tomKommentar }}</span>
          </div>
        </div>

        <label for="authorId" class="label">{{ $texter.angeNamn }}</label>
        <input 
          id="authorId"
          class="" 
          v-model="authorId" :maxlength="74" />

        <div class="comment-error" v-if="validatedAuthorId" role="alert">
          <span>{{ $texter.tomtNamn }}</span>
        </div>

        <div class="commentButton">
          <button 
            class="btn btn-primary" 
            @click="addComment()">
            {{ $texter.skickaIn }}
          </button>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: "CommentForm",
  props: {
  },
  data() {
    return {
      authorId: "",
      commentText: "",
      isLoading: false,
      isValidationAllowed: false
    }
  },
  computed: {
    validatedAuthorId() {
      return this.isValidationAllowed && !this.authorId;
    },
    validatedCommentText() {
      return this.isValidationAllowed && !this.commentText;
    }
  },
  methods:{
    async addComment() {
        try {
          this.validate();
          if (!this.validatedAuthorId && !this.validatedCommentText) {
            this.isLoading = true;
            this.$loading(true); 
            this.$commentService.addComment({
              BlockId: this.$blockId,
              AuthorId: this.authorId,
              Text: this.commentText,
            }).then((res) => {
              this.finalizeComment();        
            });  
          }
      } catch (err) {
        console.error(err);  
      }
    },
    finalizeComment() {
      this.authorId = "";
      this.commentText = "";
      this.isLoading = false;
      this.isValidationAllowed = false;
      this.$fetchData();
    },
    validate() {
      this.isValidationAllowed = true;
    }
  }
}
</script>